import { EmailNewsletterId } from "../../../components/EmailPreferencesForm/EmailPreferencesForm.types";
import { EmailPreferencesResponse } from "../api/emailPreferences.api";

export const idForKey: Record<
  keyof EmailPreferencesResponse,
  EmailNewsletterId
> = {
  account: "email-preferences-account",
  newsfeed: "email-preferences-newsfeed",
  webinars: "email-preferences-webinars",
  ignitionSupportAndProductUpdates: "email-preferences-support",
  integrators: "email-preferences-integrators",
  userFeedbackGroup: "email-preferences-user-feedback",
  ignitionCommunityConference: "email-preferences-conference",
  workspace: "email-preferences-workspace",
  workspacesActivity: "email-preferences-workspace-activity",
};

export const mapResponseToIds = (response: EmailPreferencesResponse) => {
  return Object.keys(response).reduce<string[]>((total, key) => {
    // Check if this key exists in the response
    if (response[key as keyof EmailPreferencesResponse]) {
      const id = idForKey[key as keyof EmailPreferencesResponse];
      return [...total, id];
    } else {
      return total;
    }
  }, []);
};

export const keyForId = (id: EmailNewsletterId) => {
  const entry = Array.from(Object.entries(idForKey)).find(([, v]) => v === id);
  const key = entry?.[0] as keyof EmailPreferencesResponse | undefined;

  return key;
};
